import React, { Component } from 'react';
import './header.less';
class QueryHeader extends Component {
    constructor(props) {
        super(props);
        this.state = {
            roleName: this.props.roleName,
            systemLogo:this.props.systemLogoUrl?true:false,
            systemColor:this.props.systemColor,
            systemLogoUrl:this.props.systemLogoUrl
        }
    }
    componentWillReceiveProps(props){
        this.setState({roleName:props.roleName});
        if(props.systemLogoUrl){
            this.setState({systemLogo:true,systemLogoUrl:props.systemLogoUrl});
        }
        if(props.systemColor){
            this.setState({systemColor:props.systemColor});
        }
    }
    render() {
        const {
            roleName,
            systemLogoUrl,
            systemLogo,
            systemColor
        } = this.state;
        return (
            <div className="headerClass" style={{'backgroundColor':systemColor}}>
                {
                    systemLogo&&<img className="systemLogo" src={systemLogoUrl}></img>
                }
                <span>{roleName}</span>
            </div>
        )
    }
}
export default QueryHeader;